<template>
  <div class="view-lesson">
    <v-container id="dropdown-example" fill-height>
      <v-row class="mb-2">
        <v-col cols="12">
          <div v-for="(q, index) in questions" :key="index">
            <component
              v-if="q.lesson_slide && q.lesson_slide.name"
              v-show="page === index + 1"
              class="component-wrap"
              :is="componentName[q.lesson_slide.name]"
              :activity="q"
              :activityIndex="index + 1"
            />
          </div>
        </v-col>
        <v-col cols="12">
          <v-row justify="space-between" class="flex-nowrap mt-4">
            <v-btn @click="page--" :disabled="page <= 1">
              back
            </v-btn>
            <v-pagination
              v-show="!$vuetify.breakpoint.xs"
              class="custom-pagination-no-arrows"
              v-model="page"
              :total-visible="totalVisible"
              :length="questions.length"
            />
            <v-btn @click="page++" :disabled="page >= questions.length">
              next
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BrainStorm from '@/modules/lesson/views/answers/Brainstorm'
import DragAndDrop from '@/modules/lesson/views/answers/DragAndDrop'
import SelectOptions from '@/modules/lesson/views/answers/SelectOptions'
import TextQuestion from '@/modules/lesson/views/answers/TextQuestion'
import DataTableGraphQuestion from '@/modules/lesson/views/answers/DataTableGraphQuestion'
import DataTable from '@/modules/lesson/views/answers/DataTable'
import SortActivity from '@/modules/lesson/views/answers/SortActivity'
import RadioTextQuestion from '@/modules/lesson/views/answers/RadioTextQuestion'
import SpinnerQuiz from '@/modules/lesson/views/answers/SpinnerQuiz'
import QuizLessonResult from '@/modules/lesson/views/answers/QuizLessonResult'
import DecisionTree from '@/modules/lesson/views/answers/DecisionTree.vue'

export default {
  name: 'ViewLesson',
  props: {
    questions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      componentName: {
        brainstorm: BrainStorm,
        drag_and_drop: DragAndDrop,
        text_question: TextQuestion,
        accordion_text_question: TextQuestion,
        sort_activity: SortActivity,
        select_options: SelectOptions,
        data_table: DataTable,
        radio_text_question: RadioTextQuestion,
        spinner_quiz: SpinnerQuiz,
        quiz: QuizLessonResult,
        decision_tree: DecisionTree,
        data_table_graph: DataTableGraphQuestion
      }
    }
  },
  computed: {
    totalVisible() {
      if (this.$vuetify.breakpoint.xs) {
        return 4
      } else if (this.$vuetify.breakpoint.sm) {
        return 6
      }

      return 10
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.view-lesson {
  .custom-pagination-no-arrows {
    .v-pagination__navigation {
      display: none;
    }
  }
}
</style>
